import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import ListBoxItem from "ds/components/ListBox/Item";
import TextEllipsis from "ds/components/TextEllipsis";
import Typography from "ds/components/Typography";
import { SpaceAccessLevel } from "types/generated";

import { getOptionIconSrc } from "./helpers";

type FormFieldsSpacesRoleOptionProps = {
  value: string;
  label: string;
  disabled?: boolean;
};

const FormFieldsSpacesRoleOption = (props: FormFieldsSpacesRoleOptionProps) => {
  const { disabled, value, label } = props;

  const optionIconSrc = getOptionIconSrc(value as SpaceAccessLevel);

  return (
    <ListBoxItem id={value} isDisabled={disabled} textValue={label}>
      <Box gap="medium" align="center">
        {optionIconSrc && <Icon src={optionIconSrc} noShrink />}
        <TextEllipsis tooltip={label} delay={400}>
          {(ellipsisProps) => (
            <Typography {...ellipsisProps} tag="span" variant="p-body3" color="primary">
              {label}
            </Typography>
          )}
        </TextEllipsis>
      </Box>
    </ListBoxItem>
  );
};

export default FormFieldsSpacesRoleOption;
